import {ChangeDetectorRef, Directive, HostListener} from '@angular/core';
import {FilterMenusBase} from '@components/filter-bar/filter-menus-base';

/**
 * État commun du bandeau de filtres desktop et du bouton flottant « Sauvegarder »
 * des pages de résultats (recherche et secteurs) : ouverture du bandeau, masquage
 * du bouton via sa flèche, et masquage automatique en fin de page (sinon il
 * recouvre la pagination).
 */
@Directive()
export abstract class ResultsFloatingBase extends FilterMenusBase {

    // Bandeau de filtres desktop (drawer à droite, résultats mis à jour en direct)
    filtersDrawer = false;

    // Bouton flottant masqué via sa flèche
    saveFloatingDismissed = false;

    // Bouton flottant : masqué en fin de page, sinon il recouvre la pagination
    saveFloatingAtBottom = false;

    protected constructor(protected cdr: ChangeDetectorRef) {
        super();
    }

    @HostListener('window:scroll')
    onWindowScrollFloating() {
        const remaining = document.documentElement.scrollHeight - window.scrollY - window.innerHeight;
        const atBottom = remaining < 120;
        if (atBottom !== this.saveFloatingAtBottom) {
            this.saveFloatingAtBottom = atBottom;
            // Les événements scroll ne déclenchent pas de cycle de détection ici :
            // on l'applique explicitement (uniquement au changement d'état)
            this.cdr.detectChanges();
        }
    }
}
